import React from 'react';

const Disclaimer = () => {
  return (
    <main className="min-h-screen pt-24">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-light mb-6">Disclaimer</h1>
        <div className="text-light/80 space-y-6">
          <p>
            Last updated: March 22, 2025
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Website Disclaimer</h2>
          <p>
            The information provided on the Eluno Consulting website is for general informational 
            purposes only. All information on the site is provided in good faith, however, we make 
            no representation or warranty of any kind, express or implied, regarding the accuracy, 
            adequacy, validity, reliability, availability, or completeness of any information on 
            the site.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">No Professional Advice</h2>
          <p>
            The information on our website does not constitute professional advice of any kind. 
            The content is provided for informational purposes only and should not be relied upon 
            for making any business, legal, or any other decisions. You should consult with an 
            appropriate professional for specific advice based on your situation.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">External Links Disclaimer</h2>
          <p>
            Our website may contain links to external websites that are not provided or maintained 
            by us. We do not guarantee the accuracy, relevance, timeliness, or completeness of any 
            information on these external websites.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Errors and Omissions Disclaimer</h2>
          <p>
            While we have made every attempt to ensure that the information contained on our website 
            is current and accurate, we cannot guarantee that the information is free of errors. 
            Eluno Consulting assumes no responsibility for errors or omissions in the contents on 
            the site.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Fair Use Disclaimer</h2>
          <p>
            This site may contain copyrighted material, the use of which has not always been specifically 
            authorized by the copyright owner. We believe this constitutes a 'fair use' of any such 
            copyrighted material. If you wish to use copyrighted material from this site for your own 
            purposes, you must obtain permission from the copyright owner.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Views Expressed Disclaimer</h2>
          <p>
            The views and opinions expressed in any content on our website are those of the authors and do not 
            necessarily reflect the official policy or position of Eluno Consulting. Any content provided by 
            our authors are of their opinion and are not intended to malign any religion, ethnic group, 
            club, organization, company, individual, or anyone or anything.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Contact Us</h2>
          <p>
            If you have any questions about this Disclaimer, please contact us at:
          </p>
          <p className="mt-2">
            Email: hello@eluno.consulting<br />
            Phone: (816) 678-5415
          </p>
        </div>
      </div>
    </main>
  );
};

export default Disclaimer;